import { render, staticRenderFns } from "./ResearcherPublications.vue?vue&type=template&id=160c737e&scoped=true&"
import script from "./ResearcherPublications.vue?vue&type=script&lang=js&"
export * from "./ResearcherPublications.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherPublications.vue?vue&type=style&index=0&id=160c737e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c737e",
  null
  
)

export default component.exports